module.exports = __webpack_public_path__ + "img/elementlengths_jakp.d44c43e2.png";